export const modalStyles = {
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {
      xs: '80%',
      sm: '60%',
      md: '40%',
    },
    overflow: 'hidden',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  },
  modalContent: {
    'maxHeight': '55vh',
    'overflow': 'auto',
    'marginTop': '10px',
    '&::-webkit-scrollbar': {
      width: 0,
    },
    'msOverflowStyle': 'none',
    'scrollbarWidth': 'none',
    'scrollBehavior': 'smooth',
    '&::first-letter': {
      textTransform: 'capitalize',
    },
  },
  actionButtonsContainer: {
    display: 'flex',
    marginTop: '32px',
    gap: '20px',
  },
  closeIcon: {
    position: 'absolute',
    top: '15px',
    right: '15px',
    width: '25px',
    height: '25px',
  },
};
